var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border border-dark p-2 mb-2"},[_c('BaseTextFieldGroupWithProvider',{attrs:{"empty-str-to-null":"","label":`項目名 - ${_vm._value.displayOrder + 1}`,"placeholder":"空白にするとメンバーが自由に項目名を設定できます"},model:{value:(_vm._value.name),callback:function ($$v) {_vm.$set(_vm._value, "name", $$v)},expression:"_value.name"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }